import type { Typographies } from "@superblocksteam/shared";

export const DEFAULT_FILE_PICKER_WIDGET_LABEL_STYLE_VARIANT: keyof Typographies =
  "inputLabel";
